(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bullora-contents"] && !Shopify.designMode) return;
  try {
    
(()=>{
const init=root=>{
 root.querySelectorAll('.bl-contents').forEach(section=>{
  if(section.dataset.blSlider)return;
  const track=section.querySelector('.bl-contents-list');
  const slides=Array.from(track.querySelectorAll('.bl-contents-row'));
  if(!slides.length)return;
  section.dataset.blSlider='true';
  const previous=section.querySelector('[data-bl-prev]'),next=section.querySelector('[data-bl-next]');
  const tabs=Array.from(section.querySelectorAll('[data-bl-slide]'));
  const count=section.querySelector('.bl-contents-count');
  let index=0,frame=0;
  const update=()=>{
   frame=0;
   const left=track.getBoundingClientRect().left;
   index=slides.reduce((best,slide,i)=>Math.abs(slide.getBoundingClientRect().left-left)<Math.abs(slides[best].getBoundingClientRect().left-left)?i:best,0);
   previous.disabled=index===0;
   next.disabled=index===slides.length-1;
   count.textContent=(index+1)+' / '+slides.length;
   tabs.forEach((tab,i)=>{if(i===index)tab.setAttribute('aria-current','true');else tab.removeAttribute('aria-current');});
  };
  const go=i=>{
   i=Math.max(0,Math.min(i,slides.length-1));
   const left=track.scrollLeft+slides[i].getBoundingClientRect().left-track.getBoundingClientRect().left;
   track.scrollTo({left,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
  };
  previous.addEventListener('click',()=>go(index-1));
  next.addEventListener('click',()=>go(index+1));
  tabs.forEach((tab,i)=>tab.addEventListener('click',()=>go(i)));
  track.addEventListener('scroll',()=>{if(!frame)frame=requestAnimationFrame(update);},{passive:true});
  track.addEventListener('keydown',event=>{
   if(event.target!==track)return;
   if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();go(index+(event.key==='ArrowRight'?1:-1));}
  });
  section.addEventListener('shopify:block:select',event=>{const i=slides.indexOf(event.target.closest('.bl-contents-row'));if(i>=0)go(i);});
  if('ResizeObserver'in window)new ResizeObserver(update).observe(track);
  section.querySelector('.bl-contents-controls').hidden=false;
  update();
 });
};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document),{once:true});else init(document);
document.addEventListener('shopify:section:load',()=>init(document));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bullora-home-redesign"] && !Shopify.designMode) return;
  try {
    
const bulloraVideoPreference=window.matchMedia('(prefers-reduced-motion: reduce)');
const syncBulloraVideos=()=>{
 document.querySelectorAll('.bl-redesign video').forEach(video=>{
  if(bulloraVideoPreference.matches){video.pause();video.removeAttribute('autoplay');}
  else{video.setAttribute('autoplay','');video.play().catch(()=>{});}
 });
};
syncBulloraVideos();
bulloraVideoPreference.addEventListener('change',syncBulloraVideos);
document.addEventListener('shopify:section:load',syncBulloraVideos);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
